import { useGenericContext } from "../../hooks";
import { AuthContext } from "./AuthContext";

export const useAuth = () => useGenericContext(AuthContext);
